import {Component, input, output} from '@angular/core';
import { SelectComponent } from "../select.component";
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-select-with-button',
  imports: [
    FormsModule
  ],
  templateUrl: './select-with-button.component.html',
  styleUrl: './select-with-button.component.css',
})
export class SelectWithButtonComponent extends SelectComponent {
  buttonDisabled = input<boolean>(this.disabled());
  buttonClick = output<{ id: string; value: string }>();

  onButtonClick() {
    this.buttonClick.emit({ id: this.id(), value: this.selected() });
  }
}
